import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./../../../../assets/css/general/Homelayout/RoadmapGuide/roadmapguide.css";

const Roadmap = () => {
  const navigate = useNavigate();
  const [hoveredStep, setHoveredStep] = useState(null);

  const roadmapSteps = [
    {
      id: 1,
      title: "HTML & CSS",
      status: "completed",
      tooltip: "Master the foundation of web development and visual design",
    },
    {
      id: 2,
      title: "JavaScript Basics",
      status: "completed",
      tooltip: "Learn programming fundamentals and interactive web features",
    },
    {
      id: 3,
      title: "React Fundamentals",
      status: "current",
      tooltip: "Build modern, component-based user interfaces",
    },
    {
      id: 4,
      title: "State Management",
      status: "upcoming",
      tooltip: "Handle complex application data and user interactions",
    },
    {
      id: 5,
      title: "Backend Integration",
      status: "upcoming",
      tooltip: "Connect your frontend to APIs and databases",
    },
  ];

  return (
    <section className="rm-roadmap-section">
      <div className="rm-roadmap-container">
        <div className="rm-roadmap-content">
          {/* Left Column - Text */}
          <div className="rm-roadmap-text">
            <h2 className="rm-roadmap-headline">
              Never wonder what to learn next.
            </h2>
            <p className="rm-roadmap-description">
              Most learners quit not from lack of motivation, but from lack of
              clarity. Our AI-powered platform provides a clear, step-by-step
              learning path tailored to your goals—removing confusion and
              keeping you focused.
            </p>
            <ul className="rm-roadmap-values">
              <li>What to learn</li>
              <li>When to learn it</li>
              <li>Why it matters</li>
            </ul>
          </div>

          {/* Right Column - Roadmap Preview */}
          <div className="rm-roadmap-preview">
            <div className="rm-roadmap-card">
              <div className="rm-roadmap-header">
                <h3 className="rm-roadmap-title">Frontend Developer Roadmap</h3>
                <span className="rm-roadmap-progress">3 of 5 complete</span>
              </div>

              <div className="rm-roadmap-steps">
                {roadmapSteps.map((step) => (
                  <div
                    key={step.id}
                    className={`rm-roadmap-step rm-roadmap-step--${step.status}`}
                    onMouseEnter={() => setHoveredStep(step.id)}
                    onMouseLeave={() => setHoveredStep(null)}
                  >
                    <div className="rm-step-indicator">
                      {step.status === "completed" && (
                        <svg
                          className="rm-step-icon"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline
                            className="rm-tick-mark"
                            points="20 6 9 17 4 12"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                      {step.status === "current" && (
                        <div className="rm-step-current-dot" />
                      )}
                      {step.status === "upcoming" && (
                        <div className="rm-step-upcoming-circle" />
                      )}
                    </div>

                    <div className="rm-step-content">
                      <span className="rm-step-title">{step.title}</span>
                    </div>

                    {hoveredStep === step.id && (
                      <div className="rm-step-tooltip">{step.tooltip}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={() => navigate("/roadmap")}
              className="rm-roadmap-cta"
            >
              View Learning Roadmaps →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
